import React from "react";
import { useDispatch, useSelector } from "react-redux";
import fileErrorIconAsset from "../../../assets/icons/ic-file-error.svg";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { DatalayerModalPixieButton } from "../../../libs/datalayer/components/datalayer-modal-pixie-button";
import { ClosePayrollFileErrorModal } from "../../../redux/payroll-file/actions/default";
import { RootState } from "../../../redux/reducers";

const ColumnFormatErrorsModal: React.FC = () => {
    const dispatch = useDispatch();

    const {
        error: { messages },
    } = useSelector((state: RootState) => state.payroll_file);

    const closeModal = () => {
        dispatch(new ClosePayrollFileErrorModal().create());
    };

    return (
        <div className="column-format-errors-modal">
            <div className="column-format-errors-modal__content">
                <img src={fileErrorIconAsset} />
                <SpacingBox mt={33} />
                <Typography fontSize={20} variant="gray-dark-2">
                    <b>
                        ¡Oh no!
                        <br />
                        Revisa tu planilla
                    </b>
                </Typography>
                <SpacingBox mt={19} />
                <SpacingBox pl={17} pr={17}>
                    <Typography fontSize={16} variant="gray-dark-2">
                        Encontramos los siguientes errores en tu planilla de
                        trabajadores, revísalos e inténtalo subir nuevamente:
                    </Typography>
                </SpacingBox>
                <SpacingBox mt={16} />
                <SpacingBox
                    pl={17}
                    pr={17}
                    className="format-errors-modal__messages"
                >
                    {messages.map(
                        (message, index) =>
                            message && (
                                <SpacingBox
                                    key={`column-error-${index}`}
                                    mb={5}
                                >
                                    <Typography
                                        key={message}
                                        fontSize={14}
                                        variant="gray-dark-2"
                                    >
                                        <b>{message}</b>
                                    </Typography>
                                </SpacingBox>
                            )
                    )}
                </SpacingBox>
            </div>
            <SpacingBox mt={29} />
            <DatalayerModalPixieButton
                type="button"
                kind="secondary"
                fluid
                inverse
                onClick={closeModal}
                label="Aceptar"
            >
                Aceptar
            </DatalayerModalPixieButton>
        </div>
    );
};

export default ColumnFormatErrorsModal;
